import { OperationalVm } from '@navstation-portal/reporting/data-model/vessel-report';
import { CalculatedValue } from '../with-calculated-values';

/**
 * Every Calculated Value of the Operational tab. `withCalculatedValues`
 * writes each one to the form state, and ReportStore sets its status.
 */
export const collectOperationalCalculatedValues = (vm: OperationalVm): CalculatedValue[] => [
  { sectionId: 'operatingConditions', fieldId: 'trim', value: vm.trim },
  { sectionId: 'reportTime', fieldId: 'reportPeriod', value: vm.reportPeriod },
  { sectionId: 'voyageItinerary', fieldId: 'timeInEca', value: vm.timeInEca },
  { sectionId: 'voyageItinerary', fieldId: 'inEca', value: vm.inEca },
];
